import {
  NEW_SCOPE_CATEGORIES_REQUEST,
  NEW_SCOPE_CATEGORIES_REQUEST_SUCCESS,
  NEW_SCOPE_POST_NEW_CATEGORY_REQUEST,
  NEW_SCOPE_POST_NEW_CATEGORY_REQUEST_SUCCESS,
  NEW_SCOPE_CATEGORIES_SET,
  NEW_SCOPE_DELETE_CATEGORY_REQUEST,
  NEW_SCOPE_DELETE_CATEGORY_REQUEST_SUCCESS,
  NEW_SCOPE_TOGGLE_CATEGORY_IMAGE_POPUP,
  NEW_SCOPE_SET_ACTIVE_CATEGORY_INDEX,
  NEW_SCOPE_SET_FEATURE_GROUP_SEARCH_VALUE,
  NEW_SCOPE_TOGGLE_FEATURE_GROUP_IMAGE_POPUP,
  NEW_SCOPE_SET_NEW_FEATURE_GROUP_IMAGE,
  NEW_SCOPE_SET_CATEGORIES_VISUALIZER,
  NEW_SCOPE_CATEGORIES_RESET,
  NEW_SCOPE_SET_FABRICATOR_SUBSCRIPTIONS, NEW_SCOPE_SET_FABRICATOR_SUBSCRIPTIONS_RECEIVED
} from '../../constants/actionTypes';

import PsActionsNew from "../ProjectScope/ProjectScopeActionsNew";
import {errorBox_Show, toggle_modal, loadingDialog_show} from "../../actions/A_Popups";
import {getApiConfig} from '../../utilities/index';
import {FEATURE_GROUP_ALL_NAME} from "../../constants/newScopeConstants";
import {getWizardList} from "../WizardSetup/wizardActions";
import {AVAILABLE_VISUALIZERS} from "../../constants/dashboard";

export const getQtCategories = (visualizerType = AVAILABLE_VISUALIZERS.kitchen) => {
  return (dispatch, getState) => {

    const {auth, asCustomer, newScope} = getState();

    dispatch({type: NEW_SCOPE_CATEGORIES_REQUEST});
    dispatch({
      type: NEW_SCOPE_CATEGORIES_SET,
      payload: { }
    });

    let fabricatorId =  asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    const qtCategoriesRequestCount = newScope.qtCategoriesRequestCount;
    return getApiConfig('public/featureGroupCategoriesLite/').get(fabricatorId + `/${visualizerType}/`)
      .then(async (response) => {
        //console.log('response featureGroupCategories->', response);
        // console.log("qtCategoriesRequestCount", qtCategoriesRequestCount);
        // console.log("newScope.qtCategoriesRequestCount", newScope.qtCategoriesRequestCount);
        //Sort response by order
        if (typeof response === "object" && response.__error__){
          dispatch(loadingDialog_show(false));
          if (visualizerType !== AVAILABLE_VISUALIZERS.leadform) {
            dispatch(toggle_modal(true, "Categories request error"));
          }
        }
        const {newScope} = getState();
        if (qtCategoriesRequestCount === newScope.qtCategoriesRequestCount) {
          dispatch({
            type: NEW_SCOPE_CATEGORIES_REQUEST_SUCCESS,
          });
          let qtCategories = Array.isArray(response) ? response : [];
          const allCategory = {
            name: "All",
            order: 0
          };
          if (!response || (Array.isArray(response) && !response.some(cat => cat.name === FEATURE_GROUP_ALL_NAME))) {
            qtCategories = [allCategory, ...qtCategories]
          }
          let orderIndex = 1;
          let categoriesToUpdate = [];
          qtCategories = qtCategories
            .map(qtCategory => {
              if ((!qtCategory.order && (qtCategory.order !== 0))
                || ((qtCategory.order === 0) && (qtCategory.name !== FEATURE_GROUP_ALL_NAME))) {
                qtCategory.order = orderIndex;
                orderIndex++;
                categoriesToUpdate.push(qtCategory);
              }
              return qtCategory
            })
            .sort((a, b) => a.order !== b.order ? a.order < b.order ? -1 : 1 : 0); // sort by order

          dispatch({
            type: NEW_SCOPE_CATEGORIES_SET,
            payload: {
              qtCategories
            }
          });

          const useWizard = visualizerType === AVAILABLE_VISUALIZERS.leadform || qtCategories.some(qtCat => qtCat.useWizard);
          dispatch(PsActionsNew.setWizardMode(useWizard)); // always dispatch to update when visualizers are switched
          if (useWizard) {
            await dispatch(getWizardList(newScope.categoriesVisualizer, null, false, true));
          }

          return {categoriesToUpdate, latestRequest: true}
        }
        return {categoriesToUpdate: [], latestRequest: false}
      })
      .then(({categoriesToUpdate, latestRequest}) => {
        if (categoriesToUpdate.length) {
          const promises = categoriesToUpdate.map((qtCategory) => {
            return getApiConfig(`projectScope/category`).post(qtCategory)
          });
          Promise.all(promises)
            .then((response) => {
              console.log('updated postQtCategories', response);
            })
        }
        return latestRequest
      })
      .catch((error) => {
        dispatch(loadingDialog_show(false));
        dispatch(toggle_modal(true, error));
      });
  }
};

export const getFabricatorSubscriptions = (propsFabricatorId) => {
  return (dispatch, getState) => {

    dispatch({
      type: NEW_SCOPE_SET_FABRICATOR_SUBSCRIPTIONS,
      payload: {
        fabricatorSubscriptions: [],
        fabricatorSubscriptionsReceived: false,
      }
    }); // set empty subscriptions

    const {auth, asCustomer} = getState();
    const fabricatorId = propsFabricatorId || (asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId);

    return getApiConfig('public/GetFabricatorSubscriptionInfo/').get(fabricatorId)
      .then((response) => {
        // console.log('response GetFabricatorSubscriptionInfo->', response);\
        dispatch({
          type: NEW_SCOPE_SET_FABRICATOR_SUBSCRIPTIONS_RECEIVED,
          payload: { fabricatorSubscriptionsReceived: true }
        });
        if (propsFabricatorId) {
          return response
        }
        if (!response || !response.subscriptions || !response.subscriptions.length) {
          dispatch({
            type: NEW_SCOPE_CATEGORIES_REQUEST_SUCCESS,
          });
          dispatch(errorBox_Show({
            title: 'Error',
            text: `Fabricator has no active subscriptions`,
            rightButtonText: 'OK',
            isRightButtonVisible: true
          }))
          return false
        }
        dispatch({
          type: NEW_SCOPE_SET_FABRICATOR_SUBSCRIPTIONS,
          payload: { fabricatorSubscriptions: response.subscriptions }
        });
        return response.subscriptions
      })
  }
};

export const unloadQTCategories = () => {
  return (dispatch) => {
    dispatch({
      type: NEW_SCOPE_CATEGORIES_RESET
    });
  }
}

export const deleteQtCategory = (qtCategoryId) => {
  return (dispatch, getState) => {

    const {newScope} = getState();

    dispatch(loadingDialog_show(true, "Deleting...", "Please wait while we are updating your changes."));
    dispatch({type: NEW_SCOPE_DELETE_CATEGORY_REQUEST});

    getApiConfig('projectScope/category/').delete(qtCategoryId + `/${newScope.categoriesVisualizer}/`)
      .then((response) => {
        console.log('response featureGroupCategories->', response);
        dispatch({
          type: NEW_SCOPE_DELETE_CATEGORY_REQUEST_SUCCESS,
          payload: response
        });
        dispatch(loadingDialog_show(false));
        if (newScope.activeQtCategoryIndex > (newScope.qtCategories.length - 2)) {
          dispatch({
            type: NEW_SCOPE_SET_ACTIVE_CATEGORY_INDEX,
            payload: {
              activeQtCategoryIndex: newScope.activeQtCategoryIndex - 1
            }
          });
        }
        dispatch({
          type: NEW_SCOPE_CATEGORIES_SET,
          payload: {
            qtCategories: newScope.qtCategories.filter((qtCategory) => qtCategory.id !== qtCategoryId)
          }
        })
      });
  }
};

export const postQtCategory = (qtCategory, update = false, callback = null) => {
  return (dispatch, getState) => {
    const {newScope} = getState();
    qtCategory.type = newScope.categoriesVisualizer;
    dispatch(loadingDialog_show(
      true,
      update ? 'Updating...' : 'Saving...',
      update ? 'Please wait while we are updating your changes.' : 'Please wait while we are storing your changes.'
    ));
    dispatch({type: NEW_SCOPE_POST_NEW_CATEGORY_REQUEST});

    // const {auth, asCustomer} = getState();
    // let fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;

    getApiConfig(`projectScope/category`).post(qtCategory)
      .then((response) => {
        // console.log('response', response);
        dispatch({
          type: NEW_SCOPE_POST_NEW_CATEGORY_REQUEST_SUCCESS
        });
        dispatch(loadingDialog_show(false));
        if (update) {
          const {newScope} = getState();
          dispatch({
            type: NEW_SCOPE_CATEGORIES_SET,
            payload: {
              qtCategories: newScope.qtCategories.map((qtCategory) => {
                if (qtCategory.name === response.name) {
                  return response
                }
                return qtCategory
              })
            }
          });
        }
      })
      .catch((error) => {
        dispatch(loadingDialog_show(false));
        dispatch(toggle_modal(true, error));
      });
  }
};

export const postQtCategories = (qtCategories) => {
  return (dispatch) => {

    dispatch(loadingDialog_show(true, 'Updating...', 'Please wait while we are updating your changes.'));

    const promises = qtCategories.filter(qtCat => qtCat.name !== "All").map((qtCategory) => {
      return getApiConfig(`projectScope/category`).post(qtCategory)
    });

    Promise.all(promises)
      .then((response) => {
        console.log('response postQtCategories', response);
        dispatch(loadingDialog_show(false));
      })
      .catch((error) => {
        console.log("error", error);
        dispatch(loadingDialog_show(false));
        dispatch(toggle_modal(true, error));
      });
  }
};

export const toggleQtCategoryImagePopup = (qtCategoryImageEditIndex) => {
  return (dispatch) => {
    dispatch({
      type: NEW_SCOPE_TOGGLE_CATEGORY_IMAGE_POPUP,
      payload: {
        qtCategoryImageEditIndex
      }
    });
  }
};

export const toggleFeatureGroupImagePopup = (activeImageEditFeatureGroup = null) => {
  return {
    type: NEW_SCOPE_TOGGLE_FEATURE_GROUP_IMAGE_POPUP,
    payload: {
      activeImageEditFeatureGroup
    }
  };
};

export const setQtCategories = (qtCategories) => {
  return (dispatch) => {
    dispatch({
      type: NEW_SCOPE_CATEGORIES_SET,
      payload: {
        qtCategories
      }
    });
  }
};


export const setActiveQtCategoryIndex = (activeQtCategoryIndex) => {
  return (dispatch) => {
    dispatch({
      type: NEW_SCOPE_SET_ACTIVE_CATEGORY_INDEX,
      payload: {
        activeQtCategoryIndex
      }
    });
  }
};

export const setFeatureGroupSearchValue = (featureGroupsSearchValue) => {
  return {
    type: NEW_SCOPE_SET_FEATURE_GROUP_SEARCH_VALUE,
    payload: {
      featureGroupsSearchValue
    }
  };
};

export const setNewFeatureGroupImage = (newFeatureGroupImage) => {
  return {
    type: NEW_SCOPE_SET_NEW_FEATURE_GROUP_IMAGE,
    payload: {
      newFeatureGroupImage
    }
  };
};

export const setCategoriesVisualizer = (categoriesVisualizer) => {
  return {
    type: NEW_SCOPE_SET_CATEGORIES_VISUALIZER,
    payload: { categoriesVisualizer }
  };
};

export const resetCategories = () => {
  return { type: NEW_SCOPE_CATEGORIES_RESET };
};
